<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      <v-spacer></v-spacer>
      <MgmtButtons
        :view="view"
        :acl="acl"
        :system="item.system"
        @createItem="createItem"
        :clone="true"
        @cloneItem="cloneItem"
        @deleteItem="deleteItem"
        @toView="toView"
        @toEdit="toEdit"
      />
      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab href="#system" @click="activeTab = 'system'">Системные</v-tab>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Информация</v-card-title>
                <v-card-text>
                  <table class="view-table" width="100%" >
                    <tr>
                      <th>Название:</th>
                      <td>{{ item.name }}</td>
                    </tr>

                    <tr>
                      <th>Раздел:</th>
                      <td>{{ item.model_name && item.model_name.name }}</td>
                    </tr>

                    <tr>
                      <th>Тип:</th>
                      <td>{{ item.type }}</td>
                    </tr>

                    <tr>
                      <th>Активен:</th>
                      <td>
                        <v-checkbox
                          v-model="item.is_active"
                          disabled
                        ></v-checkbox>
                      </td>
                    </tr>

                  </table>
                </v-card-text>
              </v-card>

              <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Файлы</v-card-title>
                  <div class="redactor-field">
                    <MediaList
                      :id="item.id"
                      :url="mediaUrl"
                      :acl="acl"
                      :view="view"
                      v-model="item.files"
                      :only_one="true"
                    ></MediaList>
                  </div>
              </v-card>

            </v-col>

            <v-col :cols="cols12">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Переменные</v-card-title>
                  <v-card-text>
                    <div class="mt-2" v-for="(entry, index) in item.variables" v-bind:key="entry.id">
                      <v-row>
                        <v-text-field
                            name="title"
                            v-model="entry.title"
                            placeholder="title"
                            class="ml-3"
                            label="Название переменной"
                            disabled
                          />
                        <v-text-field
                          name="name"
                          v-model="entry.name"
                          placeholder="name"
                          class="ml-3"
                          label="Переменная"
                          disabled
                        />
                        <v-text-field
                          name="path"
                          v-model="entry.path"
                          placeholder="name"
                          class="ml-3"
                          label="Путь"
                          disabled
                        />
                    </v-row>
                    </div>
                  </v-card-text>
                </v-card>

<!--               <v-card v-if="item.type == 'xlsx'" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Переменные (таблица)</v-card-title>
                  <v-card-text>
                    <div class="mt-2" v-for="(entry, index) in item.variables_custom" v-bind:key="entry.id">
                      <v-row>
                        <v-text-field
                            name="title"
                            v-model="entry.title"
                            placeholder="title"
                            class="ml-3"
                            label="Название переменной"
                            disabled
                          />
                        <v-text-field
                          name="name"
                          v-model="entry.name"
                          placeholder="name"
                          class="ml-3"
                          label="Переменная"
                          disabled
                        />
                        <v-text-field
                          name="path"
                          v-model="entry.path"
                          placeholder="name"
                          class="ml-3"
                          label="Путь"
                          disabled
                        />
                    </v-row>
                    </div>
                  </v-card-text>
                </v-card> -->

            </v-col>

          </v-row>
        </v-tab-item>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols125">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-text>
                  <table class="view-table">
                    <tr>
                      <th>Создан:</th>
                      <td>{{ item.created_by_name }}</td>
                    </tr>
                    <tr>
                      <th>Дата создания:</th>
                      <td>{{ item.date_created }}</td>
                    </tr>
                    <tr>
                      <th>Изменен:</th>
                      <td>{{ item.modified_by_name || '---' }}</td>
                    </tr>
                    <tr>
                      <th>Дата изменения:</th>
                      <td>{{ item.date_modified || '---' }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </StaticTabs>
    </v-col>

    <v-col :cols="colsBar">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <RefFilter
          class="user-filter"
          :query="initialQuery"
          :count="count"
          :filterPending="filterPending"
          :countTotal="countTotal"
          @filteredLoad="filteredLoadCollbar"
        />

      </v-row>
      <hr />
      <CollectionBar
        :id="item.id"
        :items="coll"
        :count="count"
        :loading="loadingCollbar"
        :scrollBusy="scrollBusy"
        @loadCollbar="loadCollbar"
        @toEdit="toEdit"
        @toView="toView"
      />
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import { get } from '@/api'
import RefFilter from '@/components/filters/RefFilter'
import ViewMixin from '@/views/View.vue'
import MediaList from '@/components/MediaList'

export default {
  mixins: [ViewMixin],
  components: {
    RefFilter,
    MediaList
  },
  computed: {
  },
  methods: {
    sendReport () {
      const url = `service/date_reminder/${this.item.id}/send/`
      this.loading = true
      get(url).then((response) => {
        this.loading = false
        this.$notify({ group: 'main', title: 'Отправка', text: 'Успех!', type: 'success' })
      }).catch((err) => {
        this.loading = false
        this.$notify({ group: 'main', title: 'Отправка', text: 'Ошибка!', type: 'error' })
      })
    }
  },
  data: function () {
    return {
      modelName: 'DocTemplate',
      viewName: 'doctemplate',
      viewTitle: 'Шаблоны документов',

      urlList: 'service/doctemplates/',
      urlObj: 'service/doctemplate/',

      parentHref: '#/service/doctemplate',

      loading: false,

      // medialist
      mediaUrl: 'doctemplate/',

      // item
      item: {
        id: this.id,
        name: ''
      },
      // collbar
      collbar: {
        url: 'service/doctemplates/',
        name: 'doctemplate'
      },

      items: {
      }
    }
  }
}
</script>
<style>
</style>
